module.exports = __webpack_public_path__ + "img/Play_withoutshadow.898fcbea.svg";